/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCaseNoteTemplateRequest
 */
export interface CreateCaseNoteTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCaseNoteTemplateRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCaseNoteTemplateRequest
     */
    content: string;
}

/**
 * Check if a given object implements the CreateCaseNoteTemplateRequest interface.
 */
export function instanceOfCreateCaseNoteTemplateRequest(value: object): value is CreateCaseNoteTemplateRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function CreateCaseNoteTemplateRequestFromJSON(json: any): CreateCaseNoteTemplateRequest {
    return CreateCaseNoteTemplateRequestFromJSONTyped(json, false);
}

export function CreateCaseNoteTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCaseNoteTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'content': json['content'],
    };
}

export function CreateCaseNoteTemplateRequestToJSON(json: any): CreateCaseNoteTemplateRequest {
    return CreateCaseNoteTemplateRequestToJSONTyped(json, false);
}

export function CreateCaseNoteTemplateRequestToJSONTyped(value?: CreateCaseNoteTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'content': value['content'],
    };
}

